// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-popup .error-message{font-size:var(--font-size-l);margin-bottom:10px;line-height:var(--line-height-comfortable)}.alert-popup .error-details{font-size:var(--font-size-m)}`, "",{"version":3,"sources":["webpack://./src/components/common/alert-popup/AlertPopup.scss"],"names":[],"mappings":"AACC,4BACC,4BAAA,CACA,kBAAA,CACA,0CAAA,CAED,4BACC,4BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
